// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"248":"b9f08058","283":"b016c6ee","379":"017b97e7","471":"2fa96ab0","926":"b09a6593","964":"1db39724"}[chunkId] + ".css";
};